<template>
    <div :data-component="$options.name">
        <cs-accordion
            isInitiallyOpen
            hasBorder
            label="Ort und Umkreis"
        >
            <ms-filter-location-area :locationLevels="locationLevels" />
        </cs-accordion>
        <cs-accordion
            v-if="hasValuesForFilterId(filtersForSelectedEstate[FilterId.REAL_ESTATE_PRICE_RANGES].id)"
            isInitiallyOpen
            hasBorder
            label="Preis in Euro"
        >
            <ms-filter-min-max
                :values="filterMinMaxValues[FilterCategoryKey.priceRange]"
                @update:minMaxValue="(newValue) => onUpdateMinMaxValue(newValue, FilterCategoryKey.priceRange)"
            />
        </cs-accordion>

        <cs-accordion
            v-if="hasValuesForFilterId(filtersForSelectedEstate[FilterId.REAL_ESTATE_AREA_RANGES].id)"
            isInitiallyOpen
            hasBorder
            label="Fläche"
        >
            <ms-filter-min-max
                :values="filterMinMaxValues[FilterCategoryKey.areaRange]"
                @update:minMaxValue="(newValue) => onUpdateMinMaxValue(newValue, FilterCategoryKey.areaRange)"
            />
        </cs-accordion>

        <cs-accordion
            v-if="hasValuesForFilterId(filtersForSelectedEstate[FilterId.REAL_ESTATE_ROOM_RANGES].id)"
            isInitiallyOpen
            hasBorder
            label="Zimmer"
        >
            <ms-filter-min-max
                :values="filterMinMaxValues[FilterCategoryKey.roomRange]"
                @update:minMaxValue="(newValue) => onUpdateMinMaxValue(newValue, FilterCategoryKey.roomRange)"
            />
        </cs-accordion>

        <cs-accordion
            v-if="hasValuesForFilterId(filtersForSelectedEstate[FilterId.EQUIPMENT_TYPES].id)"
            isInitiallyOpen
            hasBorder
            :label="filtersForSelectedEstate[FilterId.EQUIPMENT_TYPES].label"
        >
            <ms-filter-enhanced :searchFilters="filtersForSelectedEstate[FilterId.EQUIPMENT_TYPES]" />
        </cs-accordion>
        <cs-accordion
            v-if="hasValuesForFilterId(filtersForSelectedEstate[FilterId.FURNISHING_TYPES].id)"
            isInitiallyOpen
            hasBorder
            :label="filtersForSelectedEstate[FilterId.FURNISHING_TYPES].label"
        >
            <ms-filter-enhanced :searchFilters="filtersForSelectedEstate[FilterId.FURNISHING_TYPES]" />
        </cs-accordion>
        <cs-accordion
            v-if="hasValuesForFilterId(filtersForSelectedEstate[FilterId.REAL_ESTATE_CATEGORIES].id)"
            isInitiallyOpen
            hasBorder
            :label="filtersForSelectedEstate[FilterId.REAL_ESTATE_CATEGORIES].label"
        >
            <ms-filter-enhanced :searchFilters="filtersForSelectedEstate[FilterId.REAL_ESTATE_CATEGORIES]" />
        </cs-accordion>
        <cs-accordion
            v-if="hasValuesForFilterId(filtersForSelectedEstate[FilterId.POSITION_TYPES].id)"
            isInitiallyOpen
            hasBorder
            :label="filtersForSelectedEstate[FilterId.POSITION_TYPES].label"
        >
            <ms-filter-enhanced :searchFilters="filtersForSelectedEstate[FilterId.POSITION_TYPES]" />
        </cs-accordion>
    </div>
</template>
<script lang="ts" src="./MsResultListFilter.ts" />
